import {
  Component,
  HostListener,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';

import { XRefs } from '../../Xrefs/xrefsDataModel';
import { SearchDataService } from '../../services/searchData/search-data.service';
import { UpdateXrefsModel } from '../../models/UpdateXrefsModel';
import { UserService } from '../../services/user/user.service';
import { CanComponentDeactivate } from '../../guards/component-can-deactivate.guard';
import { GoogleAnalyticsService } from '../../services/google-analytics/google-analytics.service';
import { AuditLogService } from '../../services/audit/audit-log.service';
import { ExportFileService } from '../../services/exportFile/export-file.service';
import { FileDownloadComponent } from '../file-download/file-download.component';
import { DifferingUnspscModel } from '../../models/DifferingUnspscModel';
import { ISearchParameters } from '../page-components/Parameters/search-parameters/searchParameters';
import { DifferingUnspscService } from '../../services/differing-unspsc/differing-unspsc.service';
import { ExportFileDialogComponent } from '../dialogs/export-file-dialog/export-file-dialog.component';
import { UpdateValidationDialogComponent } from '../dialogs/update-validation-dialog/update-validation-dialog.component';
import { XrefColumnDisplayOrder } from '../../Xrefs/xref-display/xrefDisplayColumns';
import { ExportData } from '../../Xrefs/xref-display/xref-display.component';
import { UploadFileDialogComponent } from '../dialogs/upload-file-dialog/upload-file-dialog.component';
import {
  InfoDialogComponent,
  MESSAGE_ENUM,
} from '../dialogs/info-dialog/info-dialog.component';
import { Logging } from '../../utils/logging';

@Component({
  selector: 'app-search-xref',
  templateUrl: './search-xref.component.html',
  styleUrls: ['./search-xref.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class SearchXrefComponent implements OnInit, CanComponentDeactivate {
  @HostListener('window:beforeunload', [])
  onBeforeUnload(): boolean {
    return !this.hasUnsavedData();
  }
  searchBatchId;

  selectedTabIndex;

  pasteError: boolean = false;
  searchParameters: ISearchParameters = {};
  unspscSearchParameters: DifferingUnspscModel;

  canEdit: boolean = false;
  userName: string = '';
  emailAddress: string = '';

  searchParametersSectionOpen: boolean = true;

  columnOrderSetUp: XrefColumnDisplayOrder[] = [
    { defaultVisible: true, externalAllowed: false, order: 1, key: 'fromPim' },
    { defaultVisible: true, externalAllowed: true, order: 2, key: 'fromName' },
    {
      defaultVisible: true,
      externalAllowed: true,
      order: 3,
      key: 'fromPartNumber',
    },
    { defaultVisible: true, externalAllowed: true, order: 4, key: 'fromDesc' },
    { defaultVisible: true, externalAllowed: true, order: 5, key: 'fromPsc' },
    {
      defaultVisible: true,
      externalAllowed: true,
      order: 7,
      key: 'fromUNSPSC',
    },
    {
      defaultVisible: false,
      externalAllowed: false,
      order: 8,
      key: 'fromSyncGroupDesc',
    },
    {
      defaultVisible: false,
      externalAllowed: false,
      order: 9,
      key: 'fromSyncDesc',
    },
    {
      defaultVisible: false,
      externalAllowed: false,
      order: 10,
      key: 'fromContrNum',
    },
    {
      defaultVisible: true,
      externalAllowed: true,
      order: 11,
      key: 'fromNationalContractFlag',
    },
    {
      defaultVisible: false,
      externalAllowed: false,
      order: 12,
      key: 'fromItemType',
    },
    {
      defaultVisible: false,
      externalAllowed: false,
      order: 13,
      key: 'fromDiscontinuedFlag',
    },
    {
      defaultVisible: false,
      externalAllowed: false,
      order: 14,
      key: 'fromNovaPlusFlag',
    },
    { defaultVisible: true, externalAllowed: false, order: 15, key: 'toPim' },
    { defaultVisible: true, externalAllowed: true, order: 16, key: 'toName' },
    {
      defaultVisible: true,
      externalAllowed: true,
      order: 17,
      key: 'toPartNumber',
    },
    { defaultVisible: true, externalAllowed: true, order: 18, key: 'toDesc' },
    { defaultVisible: true, externalAllowed: true, order: 19, key: 'toPsc' },
    { defaultVisible: true, externalAllowed: true, order: 21, key: 'toUNSPSC' },
    {
      defaultVisible: false,
      externalAllowed: false,
      order: 22,
      key: 'toSyncGroupDesc',
    },
    {
      defaultVisible: false,
      externalAllowed: false,
      order: 23,
      key: 'toSyncDesc',
    },
    {
      defaultVisible: false,
      externalAllowed: false,
      order: 24,
      key: 'toContrNum',
    },
    {
      defaultVisible: true,
      externalAllowed: true,
      order: 25,
      key: 'toNationalContractFlag',
    },
    {
      defaultVisible: false,
      externalAllowed: false,
      order: 26,
      key: 'toItemType',
    },
    {
      defaultVisible: false,
      externalAllowed: false,
      order: 27,
      key: 'toDiscontinuedFlag',
    },
    {
      defaultVisible: false,
      externalAllowed: false,
      order: 28,
      key: 'toNovaPlusFlag',
    },
    {
      defaultVisible: true,
      externalAllowed: true,
      order: 29,
      key: 'confidenceScore',
    },
    {
      defaultVisible: true,
      externalAllowed: true,
      order: 30,
      key: 'categorizationRank',
    },
    {
      defaultVisible: false,
      externalAllowed: false,
      order: 31,
      key: 'fileBatch',
    },
    {
      defaultVisible: true,
      externalAllowed: false,
      order: 32,
      key: 'sourceType',
    },
    { defaultVisible: true, externalAllowed: false, order: 33, key: 'isValid' },
    {
      defaultVisible: false,
      externalAllowed: false,
      order: 34,
      key: 'validationNote',
    },
    {
      defaultVisible: false,
      externalAllowed: false,
      order: 35,
      key: 'isReviewed',
    },
    {
      defaultVisible: false,
      externalAllowed: false,
      order: 36,
      key: 'createDTM',
    },
  ];

  searchPageInternalExports = [
    { name: 'Internal Only', id: 1 },
    { name: 'Member Safe', id: 2 },
  ];
  searchPageExternalExports = [{ name: 'Export', id: 2 }];
  differingUnspscPageExports = [
    { name: 'Export UNSPSC', id: 1 },
    { name: 'Audit Report', id: 2 },
  ];

  searchResultsData: XRefs[] = [];

  @ViewChild('fileDownload', { static: true })
  fileDownloadComponent: FileDownloadComponent;

  //#region validation variables
  changeReason = '';

  toBeMarkedReviewed = [];
  saveError = false;
  //#endregion

  //#region UI variable for searching in progress
  hasSearched = false;
  searching = false;
  selectable = true;
  loadError = false;
  updatingXrefs = false;
  center = 'center';
  internalUser: boolean = false;
  //#endregion

  //#region Added UNSPSC functions
  isUnspscSearch: boolean = false;
  pageName(): string {
    return this.isUnspscSearch ? 'Differing UNSPSC' : 'Search';
  }
  parametersName(): string {
    return this.isUnspscSearch ? 'UNSPSC Parameters' : 'Search Parameters';
  }
  unspscSearch(value): void {
    if (value == null || value.length == 0) return;

    this.searchParametersSectionOpen = false;

    this.hasSearched = true;
    this.searching = true;
    this.loadError = false;
    this.searchResultsData = [];

    let unspscs = '';
    value.forEach(v => {
      unspscs += v.key + ',';
    });
    unspscs = unspscs.substr(0, unspscs.length - 1);

    let params: DifferingUnspscModel = {
      UnspscCodes: unspscs,
    };
    this.unspscSearchParameters = params;
    this.unspscService
      .DifferingUnspsc(params)
      .then(r => {
        this.searching = false;
        if (r == null) {
          this.loadError = true;
        } else {
          this.UpdatePageData(r);
        }
      })
      .catch(error => {
        Logging.error(error);
        this.searching = false;
        this.loadError = true;
      });
  }
  //#endregion

  constructor(
    private route: ActivatedRoute,
    private searchDataService: SearchDataService,
    public dialog: MatDialog,
    public user: UserService,
    public gaService: GoogleAnalyticsService,
    public auditService: AuditLogService,
    public exportService: ExportFileService,
    public unspscService: DifferingUnspscService,
  ) {
    user.isInternal.subscribe(v => {
      this.internalUser = v;
    });

    user.canEdit.subscribe(v => {
      this.canEdit = v;
    });
    user.emailAddress.subscribe(v => {
      this.emailAddress = v;
    });
    user.userName.subscribe(v => {
      this.userName = v;
    });
  }
  hasUnsavedData() {
    let d = this.searchResultsData.filter(d => {
      return (d.toBeReviewed && !d.isReviewed) || d.validationChange;
    });
    return d.length > 0;
  }
  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    const dirty = this.hasUnsavedData();
    if (dirty) {
      // Right now we user the browser's yes no dialog.  We can do better if wanted
      return window.confirm('You have unsaved data.\nLose changes?');
    } else {
      return true;
    }
  }

  clearParameters() {}

  ngOnInit() {
    //FOR UNSPSC PAGE SWITCH
    if (this.route.snapshot.url[0].path.toLowerCase() == 'differingunspsc')
      this.isUnspscSearch = true;

    this.searchBatchId = this.route.snapshot.queryParamMap.get('BatchId');
    if (this.searchBatchId != null) {
      setTimeout(() => {
        this.search();
      }, 0);
    }
  }

  //#region Validation and reviewed
  SaveChanges() {
    if (this.canEdit) {
      if (
        this.searchResultsData.filter(d => {
          return d.validationChange;
        }).length > 0
      ) {
        // First we need a reason that these are being changed
        const dialogRef = this.dialog.open(UpdateValidationDialogComponent, {
          width: '300px',
          data: { reason: '' },
        });

        dialogRef.afterClosed().subscribe(result => {
          this.changeReason = result;
          if (this.changeReason.length >= 3) {
            this.UpdateXrefs();
          }
        });
      } else {
        this.UpdateXrefs();
      }
    }
  }
  private UpdateXrefs() {
    // This is the actual update of the is valid and reviewed fields
    let validationChanges = '';
    let reviewedXrefs = '';
    let validationToTrue = false;

    this.searchResultsData.forEach(d => {
      if (d.toBeReviewed) reviewedXrefs += d.relationshipId + ',';
      if (d.validationChange) validationChanges += d.relationshipId + ',';
      if (d.validationChange) {
        validationToTrue = !d.isValid;
      }
    });
    if (validationChanges.substr(validationChanges.length - 1) == ',') {
      validationChanges = validationChanges.substr(
        0,
        validationChanges.length - 1,
      );
    }
    if (reviewedXrefs.substr(reviewedXrefs.length - 1) == ',') {
      reviewedXrefs = reviewedXrefs.substr(0, reviewedXrefs.length - 1);
    }
    let update: UpdateXrefsModel = {
      Message: validationChanges.length > 0 ? this.changeReason : '',
      UserName: this.userName,
      EmailAddress: this.emailAddress,
      IdsToChangeValidation: validationChanges,
      IdsToMarkReviewed: reviewedXrefs,
      SetIsValidTo: validationToTrue,
    };
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    this.updatingXrefs = true;
    this.searchDataService
      .updateXrefs(update)
      .then(res => {
        this.updatingXrefs = false;
        if (res.success) {
          this.searchResultsData.forEach(d => {
            if (d.validationChange) {
              d.validationChange = false;
              d.isValid = !d.isValid;
              d.validationNote =
                mm +
                '/' +
                dd +
                '/' +
                yyyy +
                ', ' +
                this.userName +
                ' - ' +
                this.changeReason +
                '\n' +
                d.validationNote;
            }
            if (d.toBeReviewed) {
              let date = new Date();
              d.toBeReviewed = false;
              d.isReviewed = true;
              d.reviewedBy = this.userName;
              d.reviewedDate = mm + '/' + dd + '/' + yyyy;
            }
          });
        }
      })
      .catch(ex => {
        this.updatingXrefs = false;
      });
  }
  uploadDifferingUnspscUpdate() {
    const dialogRef = this.dialog.open(UploadFileDialogComponent, {
      width: '300px',
      data: null,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let file = result;
        const dialogRef2 = this.dialog.open(UpdateValidationDialogComponent, {
          width: '300px',
          data: { reason: '' },
        });

        dialogRef2.afterClosed().subscribe(result => {
          let reason = result;
          if (reason.length >= 3) {
            this.uploadDifferingUnspecFile(file, reason);
          }
        });
      }
    });
  }
  //#endregion

  private uploadDifferingUnspecFile(theFile: any, reason: string) {
    const fileData = new FormData();
    fileData.append('file', theFile, theFile.name);
    fileData.append('user', this.userName);
    fileData.append('note', reason);
    this.searchDataService
      .uploadDifferingUnspecUpdateFile(fileData)
      .then(res => {
        let markedInvalid = res.changeToInvalid;
        let markedReviewed = res.unspecReviewedChange;
        this.dialog.open(InfoDialogComponent, {
          width: '450px',
          data: {
            messsage: MESSAGE_ENUM.DYNAMIC,
            dynamicTitle: 'UNSPSC Bulk Update',
            dynamicStatement: [
              'File name ' + theFile.name,
              markedInvalid + ' records changed to invalid.',
              markedReviewed + ' records marked as reviewed.',
            ],
          },
        });
      });
  }
  //#region search functions
  cancelSearch() {
    this.searching = false;
  }

  search() {
    let startTime = performance.now();

    this.searchParametersSectionOpen = false;
    this.selectedTabIndex = 0;

    this.hasSearched = true;
    this.searching = true;
    this.loadError = false;
    this.searchResultsData = [];

    this.searchDataService
      .searchForXrefs(this.searchParameters)
      .then(response => {
        this.searching = false;

        if (response == null) {
          this.loadError = true;
        } else {
          this.UpdatePageData(response.data);
          //Track the duration to end of search
          let endTime = performance.now();
          // eslint-disable-next-line
          var mm = moment.duration(endTime - startTime);
          let duration =
            'mm:ss:milli (' +
            mm.minutes() +
            ':' +
            mm.seconds() +
            ':' +
            Math.floor(mm.milliseconds()) +
            ')';
          this.gaService.searchDurationInfo(
            duration,
            response ? response.data.length : 0,
            this.loadError
              ? 'Error'
              : response.data.length == 0
                ? 'NoRecords'
                : 'Success',
          );
          this.gaService.searchEvent(this.searchParameters);
          this.auditService.searchEvent(
            this.searchParameters,
            duration,
            response ? response.data.length : 0,
            this.loadError
              ? 'Error'
              : response.data.length == 0
                ? 'NoRecords'
                : 'Success',
          );
        }
      })
      .catch(error => {
        Logging.error(error);
        this.searching = false;
        this.loadError = true;
      });
  }

  UpdatePageData(data: XRefs[]) {
    this.searchResultsData = data;
    this.searchResultsData.forEach(d => {
      d.validationChange = false;
      d.toBeReviewed = false;
      d.validationCheckbox = d.isValid;
    });
    data.forEach(f => {
      f.fromUNSPSC =
        f.fromUNSPSCCode == '' || !this.internalUser
          ? f.fromUNSPSCDesc
          : f.fromUNSPSCCode + ' - ' + f.fromUNSPSCDesc;
      f.toUNSPSC =
        f.toUNSPSCCode == '' || !this.internalUser
          ? f.toUNSPSCDesc
          : f.toUNSPSCCode + ' - ' + f.toUNSPSCDesc;
    });
    if (this.internalUser) {
      this.searchResultsData = data;
    } else {
      this.searchResultsData = data
        .filter(d => {
          return d.isValid;
        })
        .sort((a, b) => {
          let sc = a.fromPartNumber
            .toLowerCase()
            .localeCompare(b.fromPartNumber.toLowerCase());
          return sc != 0 ? sc : a.CategorizationRank - b.CategorizationRank;
        });
    }
  }
  //#endregion

  //#region Export
  ExportData(val) {
    if (this.isUnspscSearch) {
      if (val == 1) this.ExportUnspcItems();
      if (val == 2) this.ExportAuditReport();
    } else {
      let memberSafe = val == 2;

      const dialogRef = this.dialog.open(ExportFileDialogComponent, {
        width: '500px',
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result == '1') this.selectedTabIndex = 1;
      });
      this.searchParameters.FileType = memberSafe ? 'membersafe' : 'internal';
      let reportType = '';
      reportType = this.internalUser
        ? memberSafe
          ? 'External Member Safe'
          : 'Internal'
        : 'Member Safe';
      this.gaService.exportEvent('ODSearch', reportType);
      this.auditService.exportEvent('ODSearch', reportType);
      this.exportService.exportSearchResults(this.searchParameters);

      this.fileDownloadComponent.ExternalRefresh();
    }
  }

  exportSelection(): ExportData[] {
    if (this.isUnspscSearch) return this.differingUnspscPageExports;
    if (this.internalUser) return this.searchPageInternalExports;
    return this.searchPageExternalExports;
  }

  isMultiExport(): boolean {
    return this.isUnspscSearch || this.internalUser;
  }

  public ExportAuditReport() {
    this.unspscService.exportAuditReport();
  }

  public ExportUnspcItems() {
    this.unspscService.exportUnspcItems(
      this.unspscSearchParameters.UnspscCodes,
    );
  }
  //#endregion
}
